import React, { forwardRef, useLayoutEffect, useState } from "react"
import { FaEye, FaEyeSlash } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { CountDownTimer, Input } from "components"
import classes from "./TextField.module.scss"

const TextField = (props, ref) => {
  const {
    className = "",
    inputClassName = "",
    value = "",
    label = "",
    error,
    initialTime,
    type = "text",
    maxLength = -1,
    isPassword = false,
    onTimeout = () => { },
    onChange = () => { },
    onPaste = () => { },
    onKeyDown = () => { },
    onFocus = () => { },
    onBlur = () => { },
    disabled = false,
    ...otherProps
  } = props

  const i18n = useTranslation()[1]

  const [showPassword, setShowPassword] = useState(false)
  const [movePlaceholder, setMovePlaceholder] = useState(false)

  const handleFocus = (e) => {
    onFocus(e)

    setMovePlaceholder(true)
  }

  const handleBlur = (e) => {
    onBlur(e)

    !!value
      ? setMovePlaceholder(true)
      : setMovePlaceholder(false)
  }

  useLayoutEffect(() => {
    if (!!value) setMovePlaceholder(true)
  }, [value])

  // const maxLengthReached = value.length === maxLength

  const showHeader = !!label

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={className}>
      <div className={clsx(classes["input-container"])}>
        <Input
          ref={ref}
          value={value}
          componentType="bootstrap"
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onPaste={onPaste}
          maxLength={maxLength}
          onKeyDown={onKeyDown}
          disabled={disabled}
          placeholder=""
          type={isPassword
            ? showPassword ? "text" : "password"
            : type
          }
          className={clsx(
            classes["input"],
            disabled && classes["input-disabled"],
            !!error && classes["input-error"],
            !!isPassword && classes["icon-padding"],
            !!isPassword && isLtr && classes["icon-padding-ltr"],
            !!initialTime && classes["timer-padding"],
            !!initialTime && isLtr && classes["timer-padding-ltr"],
            inputClassName
          )}
          {...otherProps}
        />
        {
          isPassword &&
          <div
            onClick={() => setShowPassword(prev => !prev)}
            className={clsx(
              classes["is-password"],
              isLtr && classes["is-password-ltr"]
            )}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </div>
        }
        {
          !!initialTime &&
          <div
            className={clsx(
              classes["timer"],
              isLtr && classes["timer-ltr"]
            )}
          >
            <CountDownTimer
              zeroPads={{ seconds: true }}
              show={{ minutes: true, seconds: true }}
              onTimeout={onTimeout}
              initialTime={initialTime}
              inSeconds
            />
          </div>
        }
        {
          showHeader &&
          <label
            className={clsx(
              classes["placeholder"],
              isLtr && classes["placeholder-ltr"],
              movePlaceholder && classes["move"]
            )}
          >
            {label}
          </label>
        }
      </div>
      {
        !!error &&
        <div className={classes["error"]}>
          {error}
        </div>
      }
    </div>
  )
}

export default forwardRef(TextField)